import gql from 'graphql-tag';

import { executeGqlMutation } from 'src/graphql/client';
import { getSingleProp } from 'src/lib/graphql';
import type {
  BackendCustomerSetting,
  BackendMutationUpdateCustomerSettingsArgs,
} from 'src/types/backend';

const MUTATION = gql`
  mutation UpdateCustomerSettings($customerId: ID!, $blacklistWords: [String!]) {
    updateCustomerSettings(customerId: $customerId, blacklistWords: $blacklistWords) {
      blacklistWords
    }
  }
`;

type Variables = Pick<BackendMutationUpdateCustomerSettingsArgs, 'customerId' | 'blacklistWords'>;
type Result = Pick<BackendCustomerSetting, 'blacklistWords'>;

export const updateBlacklistWords = async (variables: Variables) => {
  const result = await executeGqlMutation({
    mutation: MUTATION,
    variables,
  });
  return getSingleProp<Result>(result.data)?.blacklistWords ?? [];
};
